@let isNoOptions = !isLoading() && options().length === 0;
<mat-form-field appearance="outline" class="w-full mt-2">
  <mat-label>{{label()}}</mat-label>
  <input
    matInput
    type="text"
    [matAutocomplete]="auto"
    [formControl]="inputControl()"
    [placeholder]="placeholder()">

  @if (isLoading()) {
    <mat-spinner matSuffix diameter="20"></mat-spinner>
  } @else if (inputControl().value | isString) {
    <fa-icon
      class="si-icon backspace-icon cursor-pointer mr-2 py-0"
      [matTooltip]="'Clear Search'"
      aria-hidden="true"
      [icon]="['fal', 'delete-left']"
      (click)="clear($event)"
    ></fa-icon>
  } @else {
    <span
      matSuffix
      aria-hidden="true"
      class="si-select-arrow-wrapper si-select-arrow cursor-pointer"
    >
			  <span class="si-select-arrow-icon">
          <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true">
            <path d="M7 10l5 5 5-5z"></path>
          </svg>
			  </span>
    </span>
  }
</mat-form-field>

<mat-autocomplete
  [hideSingleSelectionIndicator]="true"
  [displayWith]="displayFn"
  (opened)="onOpen()"
  #auto="matAutocomplete">
  <cdk-virtual-scroll-viewport
    [itemSize]="itemsSize"
    [minBufferPx]="itemsSize * 10"
    [maxBufferPx]="itemsSize * 10"
    [style.height]="'240px'"
    [style.max-height]="itemsSize * (options()?.length + 1 > 5 ? 5 : isNoOptions ? 2 : options()?.length + 1) +'px'"
  >
    @if (isNoOptions) {
      <mat-option disabled>
       {{noResultsFoundText()}}
      </mat-option>
    }
    <mat-option [value]="emptyKeyValueModel"
                [class.mdc-list-item--selected]="selectedSignal().default"
                (onSelectionChange)="onOptionSelected($event)"
    >
      <div class="truncate max-width-200">{{ emptyKeyValueModel.value }}</div>
    </mat-option>
    <mat-option *cdkVirtualFor="let model of options(); trackBy:trackBy"
                [value]="model"
                [class.mdc-list-item--selected]="selectedSignal().key === model.key"
                (onSelectionChange)="onOptionSelected($event)"
    >
      <div class="truncate max-width-200" [tooltipIfTruncated]="model.value">{{ model.value }}</div>
    </mat-option>
  </cdk-virtual-scroll-viewport>
</mat-autocomplete>
